import { render, staticRenderFns } from "./DashboardFeedbackList.vue?vue&type=template&id=869a32c4&scoped=true&"
import script from "./DashboardFeedbackList.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedbackList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeedbackList.vue?vue&type=style&index=0&id=869a32c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869a32c4",
  null
  
)

export default component.exports